import { ExpertiseEnum } from "./expertiseEnum";

export interface SpecialLink {
  title: string;
  href: string;
}

export interface ExpertiseSpecialLinks {
  calculator?: SpecialLink;
  // Add more special link types here as needed
}

// Special links configuration for each expertise area with direct route references
export const expertiseSpecialLinks: Partial<
  Record<ExpertiseEnum, ExpertiseSpecialLinks>
> = {
  // [ExpertiseEnum.Arbeitsrecht]: {
  //   calculator: {
  //     title: "Abfindungs&shy;rechner",
  //     href: slRoutes.calculator.abfindungsrechner,
  //   },
  // },
  // [ExpertiseEnum.Erbrecht]: {
  //   calculator: {
  //     title: "Pflichtteils&shy;rechner",
  //     href: slRoutes.calculator.pflichtteilrechner,
  //   },
  // },
  // [ExpertiseEnum.Startuprecht]: {
  //   calculator: {
  //     title: "Gründungskosten&shy;rechner",
  //     href: slRoutes.calculator.grundungskostenrechner,
  //   },
  // },
  // Other expertise areas don't have special links (yet)
};
